import { render, staticRenderFns } from "./makeMethodMange.vue?vue&type=template&id=016b54e2&scoped=true"
import script from "./makeMethodMange.vue?vue&type=script&lang=js"
export * from "./makeMethodMange.vue?vue&type=script&lang=js"
import style0 from "./makeMethodMange.vue?vue&type=style&index=0&id=016b54e2&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "016b54e2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('016b54e2')) {
      api.createRecord('016b54e2', component.options)
    } else {
      api.reload('016b54e2', component.options)
    }
    module.hot.accept("./makeMethodMange.vue?vue&type=template&id=016b54e2&scoped=true", function () {
      api.rerender('016b54e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/orderManage/makeMethodMange.vue"
export default component.exports